import React, { SVGProps } from 'react';

const ActivityIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      d="M12 21C16.9706 21 21 16.9706 21 12C21 7.02944 16.9706 3 12 3C7.02944 3 3 7.02944 3 12C3 16.9706 7.02944 21 12 21Z"
      strokeWidth="1.8"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path d="M3 12H21" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" />
    <path
      d="M12 3C13.876 5.46452 14.9421 8.66283 15 12C14.9421 15.3372 13.876 18.5355 12 21C10.124 18.5355 9.05794 15.3372 9 12C9.05794 8.66283 10.124 5.46452 12 3V3Z"
      strokeWidth="1.8"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default ActivityIcon;
